var map = {
	"./01.png": "81c4d",
	"./02.png": "62cc",
	"./03.png": "37dc",
	"./04.png": "ad29",
	"./05.png": "2e5e",
	"./06.png": "c6d5",
	"./07.png": "7d08"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6d19";